import React, {Component, Fragment} from 'react';
import {Route, Switch} from 'react-router-dom';
import Header from "../components/Header";
import NotFoundShop from "./NotFoundShop";
import ShopCart from "../components/Shop/ShopCart";
import ShopCategory from "../components/Shop/ShopCategory";
import ShopProduct from "../components/Shop/ShopProducts";
import Footer from "../components/Footer";
import PopupAddCart from "../components/Popups/PopupAddCart";

class ShopRouter extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route path="/shop/" render={this.getIndex} exact />
          <Route path="/shop/not-found-shop" render={this.getNoShop} exact/>
          {/*<Route path="/shop/not-found-shop" component={NotFoundShop} />*/}
          {/*<Redirect from="*" to="/shop/not-found-shop"/>*/}
          <Route path="/shop/:url_hash" render={this.getArticle} exact />
        </Switch>
      </div>
    )
  }

  getArticle = ({match}) => {
    const { url_hash } = match.params;
    if(url_hash) return (
        <Fragment>
          <div className="body">
            <Header selectShop={true} url_hash={url_hash} />
            <main>
              <div className="shop-chosen-and-category">
                <ShopCart/>
                <ShopCategory/>
              </div>
              <ShopProduct/>
            </main>
            <Footer/>
            <PopupAddCart/>
          </div>
        </Fragment>
      )
  }

  getIndex = ({match}) => {
    return (
      <Fragment>
        <div className="body">
          <Header selectShop={true} />
          <main>
            <div className="shop-chosen-and-category">
              <ShopCart/>
              <ShopCategory/>
            </div>
            <ShopProduct/>
          </main>
          <Footer/>
          <PopupAddCart/>
        </div>
      </Fragment>
    )
  }

  getNoShop = ({match}) => {
    return <NotFoundShop/>
  }
}

export default ShopRouter


// WEBPACK FOOTER //
// ./src/routers/Shop.js